/**
 * The page scrolls in its own box beside Genie (GlobalLayout), not in the
 * window, so its scrollbar sits at the page's edge — left of a docked Genie —
 * instead of beside Genie's own. Code that scrolls the page, or listens to it
 * scrolling, uses this element.
 */
export const PAGE_SCROLLER_ID = "admin-page-scroller";

/** The page's scroll box; the window when it is not mounted (sign-in, tests). */
export const getPageScroller = (): HTMLElement | Window =>
  document.getElementById(PAGE_SCROLLER_ID) ?? window;
